import React, { useState, useEffect } from "react";
import { IoMusicalNoteOutline } from "react-icons/io5";
import { GiCarDoor } from "react-icons/gi";
import { MdOutlineAirlineSeatReclineNormal } from "react-icons/md";
import { TbAirConditioning } from "react-icons/tb";
import { LuFuel } from "react-icons/lu";
import CabInquiryModal from "../Modal/CabInquiryModal";
import {
  ChevronLeft,
  ChevronRight,
  Heart,
  MapPin,
  Fuel,
  Settings,
  TrendingUp,
} from "lucide-react";

import axios from "axios";

import { useNavigate } from "react-router-dom";

const PopularCarsV2 = () => {
  const [favorites, setFavorites] = useState(new Set());
  const [cardImageIndexes, setCardImageIndexes] = useState({});
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);

 

  const toggleFavorite = (id) => {
    setFavorites((prev) => {
      const newFavorites = new Set(prev);
      if (newFavorites.has(id)) {
        newFavorites.delete(id);
      } else {
        newFavorites.add(id);
      }
      return newFavorites;
    });
  };

  const handleCardImageNext = (cardId, totalImages) => {
    setCardImageIndexes((prev) => ({
      ...prev,
      [cardId]: ((prev[cardId] || 0) + 1) % totalImages,
    }));
  };

  const handleCardImagePrev = (cardId, totalImages) => {
    setCardImageIndexes((prev) => ({
      ...prev,
      [cardId]: ((prev[cardId] || 0) - 1 + totalImages) % totalImages,
    }));
  };

  const getCurrentImageIndex = (cardId) => {
    return cardImageIndexes[cardId] || 0;
  };
  

  const navigate = useNavigate();

  const [cab, setCab] = useState([]);
  const [selectedCab, setSelectedCab] = useState(null);

  const fetchCabData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/cab/all-cab`,
      );
      setCab(response?.data?.data);
      console.log("cabPackage response data", response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCabData();
  }, []);

  const loopedCabs = [...cab, ...cab];

  return (
    <div className="relative w-full py-10 px-4 sm:px-6 lg:px-20">
      <div className="w-full mx-auto">
        {/* Header Section */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-rose-500/60" />
            <div className="flex items-center gap-1.5">
              <svg
                className="w-5 h-5 text-rose-400"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M3 17l4-8 4 4 4-6 4 4" />
                <path d="M21 7l-4 4" />
              </svg>
              <span className="text-rose-400 text-xs font-semibold uppercase tracking-widest">
                Trending Cars
              </span>
            </div>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-rose-500/60" />
          </div>

          <h2 className="text-2xl md:text-4xl font-black tracking-tighter mb-4">
            Trending <span className="">Cars</span>
          </h2>
          <p className="text-base md:text-lg max-w-xl mx-auto leading-relaxed mb-10">
            Gaining popularity due to advancements in battery technology and
            growing environmental awareness
          </p>
        </div>

        {/* Cards Grid */}
        <div className="relative overflow-hidden w-full">
  <div className="flex gap-6 animate-scroll w-max">
          {loopedCabs
          ?.map((car, index) => {
            const tripType = car?.tripType;

            let price = 0;
            let offerPrice = 0;

            if (tripType === "outstation") {
              price = car?.vehicles?.[0]?.pricing?.outstation?.baseAmount;
              offerPrice = car?.vehicles?.[0]?.pricing?.outstation?.finalAmount;
            } else {
              // one-way, round-trip, local
              price = car?.vehicles?.[0]?.pricing?.regular?.baseAmount;
              offerPrice = car?.vehicles?.[0]?.pricing?.regular?.finalAmount;
            }
            const currentImageIndex = getCurrentImageIndex(car?._id);
            const isHovered = hoveredCard === car?._id;

            return (
              <div
                  key={`${car._id}-${index}`}
  className="min-w-[300px] max-w-[300px] flex-shrink-0"
                // onClick={() => navigate(`/cab-details/${car?._id}`)}
                onMouseEnter={() => setHoveredCard(car?._id)}
                onMouseLeave={() => setHoveredCard(null)}
                // style={{
                //   animation: "fadeInScale 0.6s ease-out forwards",
                //   animationDelay: `${index * 100}ms`,
                //   opacity: 0,
                // }}
              >
                <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 h-full border-2 border-transparent hover:border-gray-200">
                  {/* Image Container with Individual Navigation */}
                  <div className="relative h-64 overflow-hidden">
                    {/* Image */}
                    <img
                        src={
                          car?.subImages?.length > 0
                            ? car.subImages[currentImageIndex]
                            : car?.mainImage
                        }
                        alt={car?.name}
                        className="w-full h-full object-cover transition-transform duration-500"
                      />

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>

                    {/* Top Left - Heart Icon */}
                    <div className="absolute top-4 left-4">
                      <button
                        onClick={() => toggleFavorite(car._id)}
                        className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
                      >
                        <Heart
                          className={`w-5 h-5 transition-colors duration-300 ${
                            favorites.has(car._id)
                              ? "fill-red-500 text-red-500"
                              : "text-gray-600"
                          }`}
                        />
                      </button>
                    </div>

                    {/* Top Right - Trending Badge */}
                    {car.trending && (
                      <div className="absolute top-4 right-4">
                        <div className="flex items-center space-x-1 bg-blue-600 text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg">
                          <TrendingUp className="w-3.5 h-3.5" />
                          <span>Trending</span>
                        </div>
                      </div>
                    )}

                    {/* Card-specific Navigation Arrows - Only visible on hover */}
                    {isHovered && (
                      <>
                        {/* Left Arrow */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCardImagePrev(
                              car?._id,
                              car?.subImages?.length,
                            );
                          }}
                          className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/95 backdrop-blur-sm rounded-full flex items-center justify-center shadow-xl hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-600 group/arrow transition-all duration-300 hover:scale-110 z-10 "
                        >
                          <ChevronLeft className="w-5 h-5 text-gray-700 group-hover/arrow:text-white transition-colors duration-300" />
                        </button>

                        {/* Right Arrow */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCardImageNext(
                              car?._id,
                              car?.subImages?.length,
                            );
                          }}
                          className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/95 backdrop-blur-sm rounded-full flex items-center justify-center shadow-xl hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-600 group/arrow transition-all duration-300 hover:scale-110 z-10 "
                        >
                          <ChevronRight className="w-5 h-5 text-gray-700 group-hover/arrow:text-white transition-colors duration-300" />
                        </button>
                      </>
                    )}

                    {/* Navigation Dots */}
                    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-1.5">
                      {car?.subImages?.map((_, imgIndex) => (
                        <div
                          key={imgIndex}
                          className={`w-2 h-2 rounded-full transition-all duration-300 ${
                            imgIndex === currentImageIndex
                              ? "bg-red-500 w-6"
                              : "bg-white/60"
                          }`}
                        />
                      ))}
                    </div>

                    {/* Owner Avatar */}
                  </div>

                  {/* Content Section */}
                  <div className="p-5">
                    {/* Type Badge */}
                    {/* <div className="inline-block mb-3">
                      <span className="bg-gradient-to-r from-green-400 to-green-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm">
                        {car?.cabType}
                      </span>
                    </div> */}

                    {/* Car Name */}
                    <div className="flex justify-between mb-5">
                      <h3 className="text-xl font-bold text-gray-900 group-hover:text-orange-600 transition-colors duration-300">
                      {car?.name}
                    </h3>
                     <div className="flex items-center space-x-2">
                        <div className="bg-yellow-400 text-gray-900 text-[0.65rem] font-normal px-1 py-[1px] rounded-lg">
                          {car?.avgRating}
                        </div>
                        <span className="text-xs text-gray-600">
                          ({car?.totalReviews} Reviews)
                        </span>
                      </div>
                    </div>

                    {/* Location */}
                    {/* <div className="flex items-center space-x-1 text-gray-600 text-sm mb-4">
                      <MapPin className="w-4 h-4 text-orange-500" />
                      <span>{car?.name}</span>
                    </div> */}

                    {/* Specifications Grid */}
                    <div className="grid grid-cols-4 gap-10 mb-5 pb-5 border-b border-gray-200">
                      {/* Fuel */}
                      <div className="flex gap-1 items-start">
                        <div className="flex items-center space-x-1 text-gray-500">
                          <LuFuel className="text-lg"/>
                        </div>
                        <span className="text-sm font-semibold text-gray-900 capitalize">
                          {car?.fuelType}
                        </span>
                      </div>

                      {/* Ac */}
                      <div className="flex gap-1 items-start ml-4">
                        <div className="flex items-center space-x-1 text-gray-500 text-lg ">
                          <TbAirConditioning className="text-xl" />
                          
                        </div>
                        <span className="text-sm capitalize font-semibold text-gray-900 ">
                          {car?.ac ? "yes" : "No"}
                        </span>
                      </div>

                      {/* Travelled */}
                      <div className="flex gap-1 items-start ml-3">
                        <div className="flex items-center space-x-1 text-gray-500 text-lg ">
                          <MdOutlineAirlineSeatReclineNormal className="text-xl" />
                          
                        </div>
                        <span className="text-sm font-semibold text-gray-900 ">
                          {car?.seats}
                        </span>
                      </div>
                      <div className="flex gap-1 items-start">
                        <div className="flex items-center space-x-1 text-gray-500 text-lg ">
                          <GiCarDoor className="text-xl"/>
                          
                        </div>
                        <span className="text-sm font-semibold text-gray-900 ">
                          {car?.door}
                        </span>
                      </div>
                    </div>

                    {/* Price and Rating Footer */}
                    <div className="flex justify-between">
                      <div className="flex items-center">
                      {/* Price */}
                      <div className="flex items-baseline space-x-1">
                        <span className="text-xl text-yellow-600 font-bold">
                          <span className="text-[13px] text-gray-400 font-normal">Starting at </span>
                          ₹{car?.price}
                        </span>
                        <span className="text-[13px] text-gray-500">/ Km</span>
                      </div>
                    </div>
                     <button onClick={(e) => {
                      e.stopPropagation()
                      setIsInquiryModalOpen(true)
                      setSelectedCab(car)
                     }} className="text-[15px] bg-red-500 px-3 py-2 rounded-lg text-white hover:text-red-600 border border-red-500 hover:bg-white transition duration-300">Book Now</button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div
          className="flex justify-center animate-fade-in mt-6"
          style={{ animationDelay: "800ms" }}
        >
          <button
            onClick={() => navigate(`/car`)}
            className="group relative px-8 py-3.5 bg-gray-900 text-white rounded-full font-semibold shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 overflow-hidden"
          >
            <span className="relative z-10 flex items-center space-x-2">
              <span>View All</span>
              <svg
                className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
        </div>

      </div>
      </div>

      

      {isInquiryModalOpen && (
  <CabInquiryModal
    isOpen={isInquiryModalOpen}
    onClose={() => setIsInquiryModalOpen(false)}
    cab={selectedCab}
  />
)}

      {/* Custom Styles */}
      <style jsx>{`
      @keyframes scroll {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-50%, 0, 0);
  }
}

.animate-scroll {
  display: flex;
  width: max-content;
  animation: scroll 35s linear infinite;
  will-change: transform;
}

.animate-scroll:hover {
  animation-play-state: paused;
  cursor: grab;
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-in {
          from {
            opacity: 0;
            width: 0;
          }
          to {
            opacity: 1;
            width: 100%;
          }
        }

        @keyframes slide-in-left {
          from {
            opacity: 0;
            transform: translate(-50%, -50%) translateX(-10px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -50%) translateX(0);
          }
        }

        @keyframes slide-in-right {
          from {
            opacity: 0;
            transform: translate(-50%, -50%) translateX(10px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -50%) translateX(0);
          }
        }

        @keyframes bounce-slow {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }

        // .animate-fade-in-up {
        //   animation: fade-in-up 0.8s ease-out;
        // }

        .animate-slide-up {
          animation: slide-up 0.6s ease-out forwards;
          opacity: 0;
        }

        .animate-slide-in {
          animation: slide-in 0.6s ease-out forwards;
          opacity: 0;
        }

        .animate-slide-in-left {
          animation: slide-in-left 0.3s ease-out;
        }

        .animate-slide-in-right {
          animation: slide-in-right 0.3s ease-out;
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default PopularCarsV2;
